import { useState } from 'react';
import './iconButton.css';


export default function PortalButton() {
    const [isHovered, setIsHovered] = useState<boolean>(false);

    function sendToPortal()
    {
        window.open('https://msmithaccounting.cchifirm.ca/clientportal/', '_blank');
    }


    return (
        <button
        className={`icon-button ${isHovered ? 'hovered' : ''}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={sendToPortal}
        >
            <div className="icon-button-icon">
                <i className={`fa-solid fa-envelopes-bulk ${isHovered ? "fa-bounce" : ""}`}></i>
            </div>
            <div className="icon-button-text">PORTAL</div>
        </button>
    );
}